export default {
  app: {
    name: 'Epromo',
    footer: {
      active: 'favoritos',
      items: [
        {value: 'historial', title: 'Mis Cupones', icon: 'inbox'},
        {value: 'favoritos', title: 'Promociones', icon: 'view_agenda'},
        {value: 'lugares', title: 'Locales', icon: 'place'}
      ]
    }
  },
  home: {
    categories: {
      show: false,
      items: [],
      filter: []
    },
    promotions: {
      status: 'loading',
      items: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js